<template>
  <on-click-outside @trigger="hide">
    <div @click="toggle">
      <slot name="toggle" />
    </div>
    <div
      v-show="open"
      class="origin-top-right absolute right-0 mt-2 w-60 rounded-md shadow-lg py-1 bg-white dark:bg-gray-600 ring-1 ring-black ring-opacity-5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      :aria-labelledby="label"
      tabindex="-1"
    >
      <slot />
    </div>
  </on-click-outside>
</template>

<script>
import { OnClickOutside } from '@vueuse/components'

export default {
  components: {
    OnClickOutside
  },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.hide()
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    hide () {
      this.open = false
    }
  }
}
</script>
